type APIErrorPayload = {
  non_field_errors?: string[] | string
  detail?: string
  error?: string
  message?: string
}

type APIError = {
  data?: APIErrorPayload | string
}

export const getApiErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const axiosData = (error as { response?: { data?: APIErrorPayload | string } } | undefined)
    ?.response?.data
  const response = axiosData ?? (error as APIError | undefined)?.data
  const nonFieldErrors =
    response && typeof response === 'object' ? response.non_field_errors : undefined

  if (Array.isArray(nonFieldErrors) && nonFieldErrors.length > 0) {
    return nonFieldErrors[0]
  }

  if (typeof nonFieldErrors === 'string') {
    return nonFieldErrors
  }

  if (response && typeof response === 'object' && typeof response.detail === 'string') {
    return response.detail
  }

  if (response && typeof response === 'object' && typeof response.error === 'string') {
    return response.error
  }

  if (response && typeof response === 'object' && typeof response.message === 'string') {
    return response.message
  }

  if (typeof response === 'string') {
    return response
  }

  return fallbackMessage
}
